import { render, staticRenderFns } from "./BlankLayout.vue?vue&type=template&id=d2731ea2"
var script = {}
import style0 from "./BlankLayout.vue?vue&type=style&index=0&id=d2731ea2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports